import {
    GET_TRANSACTION_PROVISION_SETTLE_LIST,
    GET_TRANSACTION_PROVISION_SETTLE_LIST_SUCCESS,
    GET_TRANSACTION_PROVISION_SETTLE_SEARCH,
    GET_TRANSACTION_PROVISION_SETTLE_SEARCH_SUCCESS,

    TRANSACTION_PROVISION_SETTLE_API_ERROR
} from "./actionTypes"

export const getTransactionProvisionSettleList = record => ({
    type: GET_TRANSACTION_PROVISION_SETTLE_LIST,
    payload: record
})

export const getTransactionProvisionSettleListSuccess = record => ({
    type: GET_TRANSACTION_PROVISION_SETTLE_LIST_SUCCESS,
    payload: record
})

export const getTransactionProvisionSettleSearch = record => ({
    type: GET_TRANSACTION_PROVISION_SETTLE_SEARCH,
    payload: record,
})
export const getTransactionProvisionSettleSearchSuccess = record => ({
    type: GET_TRANSACTION_PROVISION_SETTLE_SEARCH_SUCCESS,
    payload: record,
})


export const transactionProvisionSettleApiError = error => {
    return {
        type: TRANSACTION_PROVISION_SETTLE_API_ERROR,
        payload: error,
    }
}
